import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

export function useGetAccountIdentityUsers(accountId: string) {
  return useQuery({
    queryKey: usersQueryKeys.identityUserList(accountId),
    queryFn: ({ signal }) => UsersService.getAccountIdentityUsers(accountId, { signal }),
    enabled: Boolean(accountId),
  });
}
